import { useState } from 'react';
import { Button, Card } from './ui';

// The institute code is the cheapest way to onboard a whole class: students
// enter it in the Prepgen app (Settings → Organization → Join an Organization)
// and the owner approves them in one place. It deserves to be seen, not buried
// in sidebar small print.
export default function JoinCodeCard({ code, compact = false }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    if (!code) return;
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (_) {
      // Clipboard can be unavailable in some contexts; the code is still visible.
    }
  };

  if (compact) {
    return (
      <div className="org-code">
        <span className="org-code-label">Join code</span>
        <code>{code || '—'}</code>
        <button type="button" onClick={copy} aria-label="Copy join code" title="Copy">
          {copied ? '✓' : '⧉'}
        </button>
      </div>
    );
  }

  return (
    <Card className="code-card">
      <p className="eyebrow">Institute join code</p>
      <div className="code-card-row">
        <code>{code || '—'}</code>
        <Button variant="secondary" onClick={copy}>{copied ? 'Copied' : 'Copy code'}</Button>
      </div>
      <p className="muted">
        Students sign in to the Prepgen app with their own account, open <b>Settings</b> and
        the <b>Organization</b> tab, tap <b>Join an Organization</b>, and enter this code.
        Their request appears on your Students page for approval.
      </p>
    </Card>
  );
}
